import React from 'react';

type ScreenApplicantCheckSettingsContextProps = {
    showPricing: boolean;
};

export const ScreenApplicantCheckSettingsContext = React.createContext<ScreenApplicantCheckSettingsContextProps>({
    showPricing: true,
});
